export const SCHEDA_ALLEGA_PATHS = [
    'my_CkAltreCoopAllegaSchedaGaranziaFidi',
    'my_CkAltreCoopAllegaSchedaTrasporto',
    'my_CkAltreCoopAllegaSchedaAgricoleConferimento',
    'my_CkAltreCoopAllegaSchedaSociali',
    'my_CkAltreCoopAllegaSchedaPDL',
    'my_CkAltreCoopAllegaSchedaDettaglianti',
    'my_CkAltreCoopAllegaSchedaPesca',
    'my_CkAltreCoopAllegaSchedaConsumo',
    'my_CkAltreCoopAllegaSchedaAgricoleConsorzi',
    'my_CkAltreCoopAllegaSchedaAgricole',
    'my_CkAltreCoopAllegaSchedaEdilizie',
] as const;
